import BsButton from "react-bootstrap/Button";


function Button(props) {
  /** Base button to be used throughout all other shared buttons. */
  return <BsButton variant="secondary" {...props}>{props.children}</BsButton>
}

export default Button;
